<div class="container col-11 col-md-8 col-lg-7 col-xl-6 col-xxl-5 py-lg-4 py-md-4 py-sm-3 py-2 add-edit-page-container">
    <form [formGroup]="pageEditorForm">
        <!-- Title input -->
        <div class="row">
            <mat-form-field class="w-100">
                <input matInput formControlName="Title" class="add-edit-page-title" placeholder="Title" type="text"
                       i18n-placeholder="@@add-edit-page-placeholder-title" required>
            </mat-form-field>
        </div>
        <!-- Image container -->
        <ng-container *ngIf="!isInPictureEditMode; else pictureEditMode">
            <div class="row py-2">
                <div class="add-edit-page-banner-image-container">
                    <img *ngIf="bannerImageUrl" src="{{bannerImageUrl}}" alt="{{bannerImageAltText}}" class="add-edit-page-banner-image" />
                    <div class="add-edit-page-banner-image-mod-buttons">
                        <button class="small mr-1 mt-1" mat-mini-fab
                                aria-label="Edit banner image"
                                i18n-aria-label="@@add-edit-page-edit-banner-image-aria-label"
                                (click)="editBannerImage()">
                            <i class="fa fa-pencil mb-1" aria-hidden="true"></i>
                        </button>
                        <button *ngIf="bannerImageUrl"
                                class="small mr-1 mt-1" mat-mini-fab
                                aria-label="Remove banner image"
                                i18n-aria-label="@@add-edit-page-remove-banner-image-aria-label"
                                (click)="removeBannerImage()">
                            <i class="fa fa-trash mb-1" aria-hidden="true"></i>
                        </button>
                    </div>
                </div>
            </div>
            <div class="row py-2 pb-1 small justify-content-end" *ngIf="bannerImageText">
                <span class="font-italic">{{ bannerImageText }}</span>
            </div>

        </ng-container>

        <ng-template #pictureEditMode>

            <div class="row py-2">
                <div class="add-edit-page-banner-image-container">
                    <div class="add-edit-page-banner-image pb-2">
                        <img *ngIf="bannerImageUrl" src="{{bannerImageUrl}}" alt="{{bannerImageAltText}}" class="add-edit-page-banner-image" />
                    </div>
                </div>
            </div>
            <div class="row py-2 pb-1 small justify-content-end" *ngIf="bannerImageText">
                <span class="font-italic">{{ bannerImageText }}</span>
            </div>

            <div class="row">
                <div class="add-edit-page-banner-image-options w-100">

                    <div class="add-edit-page-banner-image-selected" *ngIf="currentlySelectedImageData">
                        <span i18n="@@add-edit-page-banner-image-selected">Image selected</span>
                        <i class="fa fa-trash pl-2" aria-label="Remove banner image" i18n-aria-label="@@add-edit-page-remove-banner-image-aria-label" (keyup.enter)="removeBannerImage()" (click)="removeBannerImage()"></i>
                    </div>

                    <mat-accordion [displayMode]="flat">
                        <mat-expansion-panel class="shadow-none mb-2">
                            <mat-expansion-panel-header collapsedHeight="*" expandedHeight="*" class="d-inline-flex pl-0">
                                <mat-panel-title class="pad">
                                    <span i18n="@@add-edit-page-banner-image-options-select-image">Select image</span>
                                </mat-panel-title>
                            </mat-expansion-panel-header>

                            <div class="add-edit-page-banner-image-options-computer" class="pad">
                                <i class="fa fa-upload pr-2" aria-hidden="true"></i>
                                <a i18n="@@add-edit-page-banner-image-options-upload-from-computer" (keyup.enter)="imageInput.click()" (click)="imageInput.click()">Upload image from computer</a>
                                <input #imageInput
                                       type="file"
                                       accept="image/png, image/jpg, image/jpeg, image/gif"
                                       (change)="handleImageUpload($event)"
                                       class="d-none">
                                <input matInput formControlName="BannerImageUrl" class="d-none" />
                            </div>

                            <mat-accordion [displayMode]="flat">
                                <mat-expansion-panel class="shadow-none">
                                    <mat-expansion-panel-header collapsedHeight="*" expandedHeight="*" class="d-inline-flex pl-0">
                                        <mat-panel-title class="pad">
                                            <i class="fa fa-picture-o pr-2" aria-hidden="true"></i>
                                            <span i18n="@@add-edit-page-banner-image-options-choose-from-gallery">Choose image from gallery</span>
                                        </mat-panel-title>
                                    </mat-expansion-panel-header>
                                    <div *ngIf="galleryImages$ | async as galleryImages; else loadingWidget" class="pad">
                                        <app-gallery [images]="galleryImages" [isSelectable]="true" [maxAmountSelectable]="1" [clearSelections]="clearGallerySelections"
                                                     (imageChange)="handleImageGalleryChange($event)"
                                                     (imageEnter)="previewImageGallery($event)"
                                                     (imageLeave)="resetImageGalleryPreview()">
                                        </app-gallery>
                                    </div>
                                </mat-expansion-panel>

                                <div class="add-edit-page-banner-image-options-imageVault pad" *ngIf="imageVaultUrl">
                                  <i class="fa fa-globe pr-2" aria-hidden="true"></i>
                                  <a i18n="@@add-edit-page-banner-image-options-from-imageVault" [href]="imageVaultUrl" [target]="'blank'">Link to ImageVault to get image URL</a>
                                </div>

                                <mat-expansion-panel class="shadow-none" *ngIf="!currentlySelectedImageFileContents || (currentlySelectedImageType && currentlySelectedImageType !== 0)">
                                    <mat-expansion-panel-header collapsedHeight="*" expandedHeight="*" class="d-inline-flex pl-0">
                                        <mat-panel-title class="pad">
                                            <i class="fa fa-globe pr-2" aria-hidden="true"></i>
                                            <span i18n="@@add-edit-page-banner-image-options-from-url">Add image from URL</span>
                                        </mat-panel-title>
                                    </mat-expansion-panel-header>
                                    <div class="pad">
                                        <mat-form-field class="w-100">
                                            <input matInput (change)="handleImageUrl()" placeholder="Image URL" i18n-placeholder="@@add-edit-page-banner-image-url" formControlName="BannerImageUrl">
                                        </mat-form-field>
                                    </div>
                                </mat-expansion-panel>
                            </mat-accordion>
                        </mat-expansion-panel>

                        <mat-expansion-panel class="w-100 shadow-none">
                            <mat-expansion-panel-header collapsedHeight="*" expandedHeight="*" class="d-inline-flex pl-0">
                                <mat-panel-title class="pad">
                                    <span i18n="@@add-edit-page-banner-image-options-image-info">Image info</span>
                                </mat-panel-title>
                            </mat-expansion-panel-header>
                            <div class="pad">
                                <mat-form-field class="w-100 pb-4">
                                    <textarea matInput cdkTextareaAutosize placeholder="Image caption" i18n-placeholder="@@add-edit-page-banner-image-caption"
                                              formControlName="BannerImageText">
                    </textarea>
                                    <mat-hint>
                                        <span i18n="@@add-edit-page-banner-image-caption-hint">This text will be shown beneath the image, if this page has one.</span>
                                    </mat-hint>
                                </mat-form-field>
                                <mat-form-field class="w-100">
                                    <textarea matInput cdkTextareaAutosize placeholder="Alternative text" i18n-placeholder="@@add-edit-page-banner-alt-text"
                                              formControlName="BannerImageAltText">
                    </textarea>
                                    <mat-hint>
                                        <span i18n="@@add-edit-page-banner-image-alt-text-hint">
                                            Provide alternative text to describe this image. Alternative text helps people with screen readers understand the content of pictures.
                                        </span>
                                    </mat-hint>
                                </mat-form-field>
                            </div>
                        </mat-expansion-panel>

                    </mat-accordion>

                </div>
            </div>

        </ng-template>

        <!-- Content editor -->
        <div class="row py-2">
            <app-html-editor class="card w-100" formControlName="Content"></app-html-editor>
        </div>
        <!-- Information owner input -->
        <div class="row py-2">
            <mat-form-field class="w-100" *ngSubscribe="selectedOwner$ as selectedOwner">
                <mat-chip-list #ownerChipList>
                    <mat-chip *ngIf="selectedOwner" [removable]="true" (removed)="removeOwner(user)">
                        {{selectedOwner.Name}}
                        <mat-icon matChipRemove>cancel</mat-icon>
                    </mat-chip>
                    <input [attr.disabled]="selectedOwner"
                           [attr.hidden]="selectedOwner"
                           type="text"
                           #ownerInput
                           [formControl]="OwnerInputControl"
                           [matAutocomplete]="auto"
                           [matChipInputFor]="ownerChipList"
                           i18n-placeholder="@@add-edit-page-owner-placeholder"
                           placeholder="Information Owner">
                    <mat-autocomplete #auto="matAutocomplete" (optionSelected)="setOwner($event)" autoActiveFirstOption>
                        <ng-container *ngIf="foundUsers$ | async as foundUsers">
                            <mat-option class="page-owner-searchform-options" *ngFor="let user of foundUsers" [value]="user">
                                {{user.Name}}
                            </mat-option>
                        </ng-container>
                    </mat-autocomplete>
                </mat-chip-list>
                <mat-hint *ngIf="noUsersFound" i18n="@@no-users-found">no users found</mat-hint>
                <span matSuffix>
                    <mat-spinner class="spinner-icon" *ngIf="searchingForUsers" [diameter]="15"></mat-spinner>
                </span>
            </mat-form-field>
            <input matInput formControlName="OwnerUserUpnId" class="d-none" />
        </div>
        <!-- Publishing Date picker -->
        <div class="row py-2">
            <mat-form-field class="w-100">
                <input matInput
                       placeholder="Publishing date"
                       autocomplete="off"
                       formControlName="PublishingDate"
                       i18n-placeholder="@@add-edit-page-placeholder-publishingdate"
                       [matDatepicker]="PublishingDatePicker">
                <mat-datepicker-toggle matSuffix [for]="PublishingDatePicker"></mat-datepicker-toggle>
                <mat-datepicker #PublishingDatePicker></mat-datepicker>
            </mat-form-field>
        </div>

        <div class="row py-2" id="LANGUAGE" *ngIf="languageFilteringEnabled">
            <ng-container *ngIf="languages$ | async as languages">
                <mat-form-field class="w-100">
                    <mat-label i18n="@@page-language">Language</mat-label>
                    <mat-select formControlName="LanguageTermId" placeholder="Language" i18n-placeholder="@@page-language-placeholder">
                        <mat-option i18n="@@page-no-language-option">None</mat-option>
                        <mat-option *ngFor="let language of languages" [value]="language.Guid">{{language.Name}}</mat-option>
                    </mat-select>
                    <!--<mat-hint i18n="@@page-language-hint">The page will only show for users matching the selected language</mat-hint>-->
                </mat-form-field>
            </ng-container>
        </div>

        <!-- Channel picker -->
        <div *ngIf="channels$ | async as channels" class="row">
            <mat-form-field class="w-100">
                <mat-chip-list #channelChipList>
                    <mat-chip *ngFor="let channel of selectedChannels" [value]="channel.Guid" [removable]="true" (removed)="removeChannel(channel)">
                        {{channel.Name}}
                        <mat-icon matChipRemove>cancel</mat-icon>
                    </mat-chip>
                    <input [matChipInputFor]="channelChipList"
                           placeholder="Channels"
                           i18n-placeholder="@@placeholder-channels"
                           (focus)="channelFocus()"
                           readonly
                           #overlayOrigin="cdkOverlayOrigin"
                           cdkOverlayOrigin>
                           <span *ngIf="selectedChannels && selectedChannels.length > 1" matSuffix tabindex="0" class="info-icon" (click)="removeAllChannels()" (keyup.enter)="removeAllChannels()">
                            <i class="fa fa-times ml-2 mr-2 clickable" aria-hidden="true"></i>
                          </span>
                </mat-chip-list>
                <mat-hint *ngIf="removedChannels === 1" class="channel-removed-error" i18n="@@channel-removed-error">One channel was removed because it no longer exists in SharePoint</mat-hint>
                <mat-hint *ngIf="removedChannels > 1" class="channel-removed-error" i18n="@@channels-removed-error">{{removedChannels}} channels were removed because they no longer exist in SharePoint</mat-hint>
            </mat-form-field>
            <input matInput formControlName="ChannelTermPages" class="d-none" />
            <ng-template cdk-connected-overlay
                         cdkConnectedOverlayHasBackdrop
                         cdkConnectedOverlayBackdropClass="cdk-overlay-transparent-backdrop"
                         cdkConnectedOverlayPush
                         cdkConnectedOverlayGrowAfterOpen
                         cdkConnectedOverlayFlexibleDimensions
                         [cdkConnectedOverlayMinWidth]="_triggerRect?.width"
                         [cdkConnectedOverlayMinHeight]="_triggerRect?.height * 2"
                         [cdkConnectedOverlayOrigin]="overlayOrigin"
                         [cdkConnectedOverlayOpen]="channelMenuOpen"
                         (backdropClick)="channelMenuOpen=false">
                <div *ngIf="channels" class="mat-select-panel">
                    <app-channel-control [channels]="channels" (selectionChange)="handleChange($event)"></app-channel-control>
                </div>
            </ng-template>
        </div>
        <!-- Featured news slider-->
        <div class="d-flex row py-2" *ngIf="isNewsPage && enableFeaturedPages">
            <mat-slide-toggle formControlName="IsFeaturedPage" i18n="@@add-edit-page-featured-slider-text">Show as top news</mat-slide-toggle>
        </div>
        <!-- Comments enabled slider-->
        <div class="d-flex row py-2">
            <mat-slide-toggle formControlName="IsCommentsEnabled" i18n="@@add-edit-page-comments-slider-text">Enable comments</mat-slide-toggle>
        </div>
        <!-- Notify users-->
        <div class="d-flex row py-2" *ngIf="isNewsPage && enableNotificationSubscriptions">
            <mat-slide-toggle formControlName="Notify" i18n="@@send-notification-label">Send notification</mat-slide-toggle>
        </div>
        <!-- Save / Cancel buttons -->
        <div class="d-flex row py-2">
            <button mat-flat-button class="subtle-button-color" [routerLink]="['',{ outlets: { modal: ['audits','pages',existingPage.Id] } }]" i18n="@@view-audit-trail" *ngIf="auditsEnabled && existingPage">View audit log</button>
            <button mat-flat-button class="subtle-button-color ml-3" (click)="delete()" *ngIf="existingPage" i18n="@@add-edit-page-delete-page-button">Delete page</button>
            <button mat-button color="primary" class="ml-auto mr-3" [routerLink]="['../']" i18n="@@add-edit-page-cancel-button">Cancel</button>
            <button mat-flat-button color="accent" class="primary-contrast-color"
                    (click)="save()" [disabled]="saveBtnDisabled || !pageEditorForm.valid"
                    i18n="@@add-edit-page-save-button">
                Save page
            </button>
        </div>
    </form>
</div>

<ng-template #loadingWidget>
    <div>
        <app-widget-placeholder></app-widget-placeholder>
    </div>
</ng-template>
